export var __useDefault = true; export default "<div class=\"Card-heading\">\n    <%- T_('Select Country Site') %>\n</div>\n";